import { render, staticRenderFns } from "./IdentifyInfoModal.vue.js?vue&type=template&id=dc01d64c&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./IdentifyInfoModal.vue?vue&type=template&id=dc01d64c&scoped=true"
import script from "./IdentifyInfoModal.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./IdentifyInfoModal.vue?vue&type=script&lang=js"
export * from "./IdentifyInfoModal.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./IdentifyInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc01d64c",
  null
  
)

export default component.exports